function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LeaderboardTemplate = require('./leaderboard.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var Leaderboard = /*#__PURE__*/function () {
  function Leaderboard(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.league-overlay-leaderboard';
    var league = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    _classCallCheck(this, Leaderboard);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.league = league;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(Leaderboard, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var title, gm;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.league == null)) {
                _context.n = 1;
                break;
              }
              console.error('ERROR: leaderboard does not have league defined');
              return _context.a(2);
            case 1:
              title = 'Games';
              gm = this.app.modules.returnModuleByName(this.league.game);
              if (gm) {
                title = gm.statistical_unit + 's';
              }
              if (document.querySelector('.league-leaderboard')) {
                this.app.browser.replaceElementBySelector(LeaderboardTemplate(title), '.league-leaderboard');
              } else {
                this.app.browser.addElementToSelector(LeaderboardTemplate(title), this.container);
              }

              //
              //
              this.renderLeaderboardContents();
              //
              // fetch league info if it is not already downloaded
              //
              if (this.league.players.length == 0 || !this.league.timestamp || this.league.timestamp + 900000 < new Date().getTime()) {
                if (this.mod.debug) {
                  console.debug(this.league.numPlayers, this.league.players.length, 'Query Server for leaderboard');
                }
                this.mod.fetchLeagueLeaderboard(this.league.id, function (rows) {
                  _this.renderLeaderboardContents();
                });
              }
              this.attachEvents();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderLeaderboardContents",
    value: function renderLeaderboardContents() {
      //
      // safety check
      //
      if (!document.querySelector('.league-leaderboard .saito-table-body')) {
        return;
      }
      document.querySelector('.league-leaderboard .saito-table-body').innerHTML = '';

      //
      // add players
      //
      for (var i = 0; i < this.league.players.length; i++) {
        var html = '';
        var player = this.league.players[i];
        var publicKey = player.publicKey;
        html += "\n        <div class=\"saito-table-row".concat(publicKey == this.mod.publicKey ? ' my-leaderboard-position' : '', "\">\n          <div class=\"center-align\">").concat(i + 1, "</div>\n          ").concat(this.app.browser.returnAddressHTML(publicKey), "\n          <div class=\"right-align\">").concat(Math.round(player.score), "</div>\n          <div class=\"right-align\">").concat(Math.round(player.games_finished), "</div>\n          <div class=\"right-align\">").concat(Math.round(player.games_won), "</div>\n        </div>\n      ");

        //Player score is stored as an integer, but we round just in case things change

        this.app.browser.addElementToSelector(html, '.league-leaderboard .saito-table-body');
      }
      var container = document.querySelector(this.container);
      if (container.getBoundingClientRect().bottom < window.innerHeight) {
        var myListing = document.querySelector('.my-leaderboard-position');
        if (myListing) {
          myListing.scrollIntoView(false);

          //Old way: scroll to top then shift down
          //myListing.parentElement.parentElement.parentElement.parentElement.scrollBy(0,	-84);
        }
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var gm = this.app.modules.returnModuleByName(this.league.game);
      var obj = gm === null || gm === void 0 ? void 0 : gm.respondTo('default-league');
      var html = "<div class=\"ranking-overlay\">\n\t\t\t\t\t<h5>".concat(obj.name, " Leaderboard Score</h5>\n\t\t\t\t\t<div>This game uses ").concat(obj.ranking_algorithm, " to calculate your score, which starts at ").concat(obj.default_score, "</div>");
      if (obj.ranking_algorithm == 'EXP') {
        html += "<div>Players get \"EXP\" (experience points) for playing the game, one point minimum for trying and five points for beating a round.</div>";
      } else if (obj.ranking_algorithm == 'HSC') {
        html += "<div>The game includes its own measurement of score, so players are ranked based on who can achieve the highest score. Unlike an Arcade, each player only gets one entry.</div>";
      } else if (obj.ranking_algorithm == 'ELO') {
        html += "<div>This is the classic ranking algorithm where the amount each player's score is adjusted up or down based on the difference in their scores, i.e. the estimated likelihood that one player would beat the other. You gain more points by beating players with higher ELO scores than beating lower rated players.</div>";
      }
      html += "<div>NOTE: all leaderboards have a decay algorithm that takes away a point for every day of inactivity.</div>";
      html += "</div>";
      if (document.querySelector('.league-score-header')) {
        document.querySelector('.league-score-header').onclick = function (e) {
          console.log(e);
          console.log(e.currentTarget);
          _this2.overlay.show(html);
          _this2.overlay.move(e.clientY + 20, Math.max(0, Math.min(e.clientX - 180, window.innerWidth - 460)));
          _this2.overlay.setBackgroundColor('#0000');
        };
      }
    }
  }]);
}();
module.exports = Leaderboard;